<template>
  <div>
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="120px" :hide-required-asterisk="false">
        <div>
          <el-form-item label="话题类型" prop="topicType" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-select v-model="form.topicType" placeholder="请选择类型" filterable>
              <el-option v-for="(item,index) in Tool.map2arr($enums.topicType)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <div style="display: flex;">
              <div style="margin: 0 10px;">
                <div>
                  <el-image v-if="form.logoUrl" :src="form.logoUrl" :preview-src-list="[form.logoUrl]" style="width: 50px;height: 50px;"></el-image>
                </div>
                <el-upload v-if="form.topicType == 0" class="inline-block" action="" :http-request="uploadOSS1" :data="form" :show-file-list="false" :before-upload="beforeAvatarUpload"
                           accept=".png,.jpg,.gif">
                  <el-button type="text" style="color: #1890FF;margin-left: 0px;">上传logo</el-button>
                </el-upload>
              </div>
              <div style="margin: 0 10px;">
                <div>
                  <el-image v-if="form.backUrl" :src="form.backUrl" :preview-src-list="[form.backUrl]" style="width: 50px;height: 50px;"></el-image>
                </div>
                <el-upload v-if="form.topicType == 0" class="inline-block" action="" :http-request="uploadOSS2" :data="form" :show-file-list="false" :before-upload="beforeAvatarUpload"
                           accept=".png,.jpg,.gif">
                  <el-button type="text" style="color: #1890FF;margin-left: 0px;">上传背景图</el-button>
                </el-upload>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topic-logo-edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: {}
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async uploadOSS1 (event) {
      try {
        if (event.file.size > 1024 * 1024 * 2) {
          throw new Error('仅支持JPG、PNG、GIF格式图片文件，且文件大小小于2MB')
        }
        let url = await this.$HTTP.ApiOss.uploadOSS(event.file, `artcircle`, '.png,.jpg,.gif', 'public-read')
        await this.$HTTP.ApiTopic.getTopicInfo({ topicId: event.data.id, logoUrl: url, thumbLogoUrl: url })
        this.form.logoUrl = await this.$HTTP.ApiOss.signatureUrl(url, 'public-read')
        await this.initForm()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async uploadOSS2 (event) {
      try {
        if (event.file.size > 1024 * 1024 * 2) {
          throw new Error('仅支持JPG、PNG、GIF格式图片文件，且文件大小小于2MB')
        }
        let url = await this.$HTTP.ApiOss.uploadOSS(event.file, `artcircle`, '.png,.jpg,.gif', 'public-read')
        await this.$HTTP.ApiTopic.getTopicInfo({ topicId: event.data.id, backUrl: url })
        this.form.backUrl = await this.$HTTP.ApiOss.signatureUrl(url, 'public-read')
        await this.initForm()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async initForm () {
      if (this.row) {
        this.$nextTick(() => {
          this.form = this.row
        })
      }
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        if (this.form.topicType === 0) {
          if (!this.form.logoUrl && !this.form.backUrl) {
            this.$message({ type: 'error', message: '请上传logo和背景图' })
          } else {
            await this.$HTTP.ApiTopic.getTopicInfo({ topicId: this.row.id, topicType: this.form.topicType })
            this.$message({ type: 'success', message: '操作成功' })
            this.$emit('close')
          }
        } else {
          await this.$HTTP.ApiTopic.getTopicInfo({ topicId: this.row.id, topicType: this.form.topicType })
          this.$message({ type: 'success', message: '操作成功' })
          this.$emit('close')
        }
      } else {
        this.$message({ type: 'error', message: '请选择类型' })
      }
    },
    beforeAvatarUpload (file) {
      let _this = this
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 / 1024 < 10 // 判定图片大小是否小于10MB
        if (!isLt2M) {
          reject()
        }
        let image = new Image(), resultBlob = ''
        image.src = URL.createObjectURL(file)
        image.onload = () => {
          // 调用方法获取blob格式，方法写在下边
          resultBlob = _this.compressUpload(image, file)
          resolve(resultBlob)
        }
        image.onerror = () => {
          reject()
        }
      })
    },
    /* 图片压缩方法-canvas压缩 */
    compressUpload (image, file) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let initSize = image.src.length
      console.log(initSize)
      let { width } = image, { height } = image
      canvas.width = width
      canvas.height = height
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(image, 0, 0, width, height)

      // 进行最小压缩0.1
      let compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.1)
      // 压缩后调用方法进行base64转Blob，方法写在下边
      let blobImg = this.dataURItoBlob(compressData)
      return blobImg
    },
    /* base64转Blob对象 */
    dataURItoBlob (data) {
      let byteString
      if (data.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(data.split(',')[1])
      } else {
        byteString = unescape(data.split(',')[1])
      }
      let mimeString = data
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    }
  }
}
</script>

<style scoped>

</style>
